export function dataToMarkdown(html: string) {
  throw new Error('dataToMarkdown called on the client!');
}

export function markdownToHtml(markdown: string) {
  throw new Error('markdownToHtml called on the client!');
}

